import React, { useState, useContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Switch } from '@paypalcorp/pp-react';
import style from './SectionToggle.module.less';
import IntegrationPageSectionContext from '../StateManagement/IntegrationPageSectionContext';
import { trackButtonChange } from '../../../lib/fpti';

export default function SectionToggle({
  contentKey,
  sectionKey,
  label,
  title,
  checked,
  selectable
}) {
  const [isChecked, setIsChecked] = useState(checked);
  const {
    code: { updateActiveCodeBlock, updateCurrentSectionKey, updateAppSwitch, status },
    OrderConfigurator: { update3dsSetting },
    appSwitch
  } = useContext(IntegrationPageSectionContext);

  const contentKeyArr = contentKey?.split(',');

  // Check app switch toggle for its query param
  useEffect(() => {
    const params = new URLSearchParams(window.location.href.split('?')[1]);
    const appSwitchQueryParam = params.get('appswitch') === 'true';
    if (contentKeyArr?.includes('enableAppSwitch') && appSwitchQueryParam && !appSwitch) {
      setIsChecked(true);
      updateAppSwitch(true);
      updateActiveCodeBlock({ key: contentKeyArr, value: true });
    }
  }, []);

  useEffect(() => {
    if (!checked) return;
    const keysToUpdate = contentKeyArr.filter((contentKeyItem) => !status[contentKeyItem]);
    if (keysToUpdate.length > 0) {
      updateActiveCodeBlock({ key: keysToUpdate, value: true });
    }
  }, []);

  const handleOnChange = (event) => {
    // unset 3ds selection
    if (contentKey === '3dsConfiguration' && !event.target.checked) {
      update3dsSetting(null);
    }
    trackButtonChange(title, event.target.checked);
    setIsChecked(event.target.checked);
    if (contentKeyArr) {
      /*TODO: Remove below constant logic once generic logic is in place to handle
         multiple code wrapper in code key list
      */

      if (sectionKey === 'iStandardContactModule') {
        if (status['handleShippingAddress']) {
          delete contentKeyArr[2];
        }
      }

      updateActiveCodeBlock({ key: contentKeyArr, value: event.target.checked });
      if (selectable !== false) {
        updateCurrentSectionKey(event.target.checked ? sectionKey : undefined);
      }
      if (contentKeyArr?.includes('enableAppSwitch')) {
        updateAppSwitch(event.target.checked);
      }
    }
  };
  return (
    <Switch
      className={style.section_toggle}
      label={label}
      hideLabel
      onChange={(event) => handleOnChange(event)}
      checked={isChecked}
    />
  );
}

SectionToggle.propTypes = {
  contentKey: PropTypes.string.isRequired,
  sectionKey: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  checked: PropTypes.bool.isRequired
};
